import { isBond, isIndexToken, isStockToken } from '@swarm/core/shared/utils'
import { isXGoldByAddress } from '@swarm/core/shared/utils/tokens/gold'
import { InvestToken } from '@swarm/types/tokens/invest'
import { useTranslation } from 'react-i18next'

const useCardText = (token: InvestToken) => {
  const { t } = useTranslation('invest')

  if (isStockToken(token)) {
    return {
      currentPrice: t('stockTokens.currentStockPrice'),
      description: t('stockTokens.description'),
    }
  }

  if (isBond(token)) {
    return {
      currentPrice: t('bonds.currentBondPrice'),
      description: t('bonds.description'),
    }
  }

  if (isIndexToken(token)) {
    return {
      currentPrice: t('indexTokens.currentIndexPrice'),
      description: t('indexTokens.description'),
    }
  }

  if (isIndexToken(token)) {
    return {
      currentPrice: t('indexTokens.currentIndexPrice'),
      description: t('indexTokens.description'),
    }
  }

  if (isXGoldByAddress(token.id)) {
    return {
      currentPrice: t('xGold.currentPrice'),
      description: t('xGold.description'),
    }
  }

  return {
    currentPrice: '',
    description: '',
  }
}

export default useCardText
